export default __webpack_public_path__ + "static/Row 1.3_Pei Hwa-621b0a0618012733fff05f30bec9fea5.jpg";